export default "__VITE_ASSET__5k8XDbWG__"